
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import ImageUploader2 from '@/components/utils/ImageUploader2.vue';
import { ImageWithDimensions } from '@/utils/models';

@Component({ components: { Popup, ImageUploader2 } })
export default class ImageUploadPopup extends Vue {
  @Emit()
  close() {}
  async onApplyImage(imageFile: File) {
    const url = URL.createObjectURL(imageFile);
    const img = document.createElement('img');
    img.onload = () => {
      URL.revokeObjectURL(url);
      let image: ImageWithDimensions = { width: img.width, height: img.height, file: imageFile, base64: '' };
      this.$store.commit('SetUploadedImageBase64', image);
      this.close();
    };
    img.src = url;
  }
}
